import React from "react";
import { Account } from "@rentablo/api/apiv1";
import { AdditionalContraList } from "@features/accounts/edit/components/AdditionalContraAccounts/ContraAccountGroups";

interface Props {
  accounts: Account[];
  isMutating: boolean;
  pendingAccountId?: number;
  onSetPrimary: (id: number) => void;
  onRemove: (id: number) => void;
}

export const AdditionalAccountsSection = ({
  accounts,
  isMutating,
  pendingAccountId,
  onSetPrimary,
  onRemove,
}: Props) => {
  if (accounts.length === 0) return null;

  return (
    <AdditionalContraList
      accounts={accounts}
      isMutating={isMutating}
      pendingAccountId={pendingAccountId}
      onSetPrimary={onSetPrimary}
      onRemove={onRemove}
    />
  );
};
